import React, { useContext, useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import moment from "moment-timezone";
import Curogram from "../../assets/curogramIcon.png";
import Meet from "../../assets/meetIcon.png";
import Teams from "../../assets/teams.png";
import Zoom from "../../assets/zoom.svg";
import ScribeAi from "../../assets/mic.png";
import { useNavigate } from "react-router-dom";
import { DateRange } from "react-date-range";
import { ReactComponent as Search } from "../../assets/search.svg";
import AuthContext from "../../store/AuthContext";
import { set } from "date-fns";
import { useDebounce } from "../../hooks/useDebounce";
import { RotatingLines } from "react-loader-spinner";
import { ThemeContext } from "../../store/ThemeContext";

function msToTime(s) {
  var ms = s % 1000;
  s = (s - ms) / 1000;
  var secs = s % 60;
  s = (s - secs) / 60;
  var mins = s % 60;
  var hrs = (s - mins) / 60;

  return hrs + " hrs " + mins + " mins " + secs + " secs ";
}

const Table = ({
  data,
  pending,
  searchKeyWord,
  setSearchKeyWord,
  state,
  setIsOpen,
  setFunctionData,
  dontShow,
  setPageNumber,
  setRowsPerPage,
  rowsPerPage,
  totalRows,
  pageNumber,
  manageSortBy,
  handleDateChange,
  handleSearchKeyword,
  sortOrderPrev,
  correctIcon = true,
  platformSelected,
  handleChangePlatform,
}) => {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(state);
  const [query, setQuery] = useState(searchKeyWord);
  const [sortOrder, setSortOrder] = useState(sortOrderPrev === "desc" ? 2 : 0);
  const [clicked, setClicked] = useState(sortOrderPrev);
  const { theme, toggleTheme, themeMode } = useContext(ThemeContext);

  const inputRef = useRef(null);

  const handleSort = (row, sortDirection) => {
    manageSortBy(row.sortField, sortDirection);
    setSortOrder((sortOrder + 1) % 3);
    console.log((sortOrder + 1) % 3);
    setClicked(sortDirection);
  };

  // const handleKeyDown = (event) => {
  //   if (event.key === "Enter") {
  //     handleSearchKeyword(query);
  //     if (inputRef.current) {
  //       inputRef.current.blur();
  //     }
  //     // Call the onSearch function when Enter is pressed
  //   }
  // };

  const debouncedSearch = useDebounce((searchValue) => {
    handleSearchKeyword(searchValue);
    if (inputRef.current) {
      inputRef.current.blur();
    }
    // Your API call or search logic goes here
  }, 1500); // 500ms debounce delay

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setQuery(value);
    debouncedSearch(value); // Call the debounced function
  };

  const columns = [
    {
      name: "",
      cell: (row) => (
        <span>
          {row.meetingPlatform === "CUROGRAM" ? (
            <img
              style={{ height: "20px" }}
              src={Curogram}
              data-tag="allowRowEvents"
              alt="Curogram"
            />
          ) : row.meetingPlatform === "MEET" ? (
            <img
              style={{ height: "20px" }}
              src={Meet}
              data-tag="allowRowEvents"
              alt="Meet"
            />
          ) : row.meetingPlatform === "ZOOM" ? (
            <img
              style={{ height: "20px" }}
              src={Zoom}
              data-tag="allowRowEvents"
              alt="Zoom"
            />
          ) : row.meetingPlatform === "SCRIBE-AI" ? (
            <img
              style={{ height: "20px" }}
              src={ScribeAi}
              data-tag="allowRowEvents"
              alt="ScribeAi"
            />
          ) : (
            <img
              style={{ height: "20px" }}
              src={Teams}
              data-tag="allowRowEvents"
              alt="MSTeams"
            />
          )}
        </span>
      ),
      width: "56px",
    },
    {
      name: "Meeting",
      selector: (row) =>
        row?.meetingName?.length > 50
          ? row?.meetingName?.substr(0, 50) + "..."
          : row?.meetingName,
      grow: 2,
    },
    (authCtx.isAdmin === true || authCtx.isSuperAdmin === true) && {
      name: "Provider/Scribe",
      selector: (row) => row?.user?.Name,
    },
    {
      name: (
        <div id="date-title">
          Date
          {!correctIcon ? (
            <spam id="sort-icon">{sortOrder <= 1 ? "▲" : "▼"}</spam>
          ) : (
            <spam id="sort-icon">{clicked === "asc" ? "▲" : "▼"}</spam>
          )}
        </div>
      ),
      cell: (row) =>
        moment(row.createdAt).tz("America/New_York").format("dddd MMMM Do"),
      selector: (row) => row.createdAt,
      sortField: "createdAt",
      sortable: true,
    },
    {
      name: "Time",
      selector: (row) =>
        moment(row.createdAt).tz("America/New_York").format("h:mm a"),
      width: "100px",
    },
    {
      name: "Duration",
      selector: (row) => msToTime(row.duration),
    },
    {
      name: "Action",
      cell: (row) => (
        <span
          style={{
            color: theme?.hightlightColor,
            fontWeight: 400,
            fontSize: 15,
            marginLeft: "3%",
          }}
          onClick={() => {
            setIsOpen(true);
            setFunctionData({
              type: "DELETE-TRANSCRIPT",
              data: { id: row.id },
            });
          }}
        >
          <ion-icon name="trash"></ion-icon>
        </span>
      ),
      width: "100px",
      center: true,
      ignoreRowClick: true,
    },
  ];

  return (
    <div style={{ position: "relative" }}>
      {dontShow === true ? (
        <></>
      ) : (
        <>
          {showDatePicker === true && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                zIndex: "999",
                background: "rgb(248, 248, 248)",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid gray",
                flexDirection: "column",
                gap: "10px",
                right: "0%",
              }}
            >
              <DateRange
                rangeColors={["#6e75ff", "red", "green"]}
                color={"red"}
                editableDateInputs={true}
                onChange={(item) => {
                  setSelectedDateRange([item.selection]);
                }}
                moveRangeOnFirstSelection={false}
                ranges={selectedDateRange}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  gap: "10px",
                }}
              >
                <span
                  className="date-picker-button"
                  onClick={() => {
                    setShowDatePicker(false);
                    handleDateChange([
                      { startDate: null, endDate: null, key: "selection" },
                    ]);
                  }}
                >
                  Cancel
                </span>

                <span
                  className="date-picker-button"
                  onClick={() => {
                    handleDateChange(selectedDateRange);
                    setShowDatePicker(false);
                  }}
                >
                  Apply
                </span>
              </div>
            </div>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              userSelect: "none",
              paddingBottom: "20px",
              gap: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "360px",
                height: "40px",
                background: "rgb(246, 246, 246)",
                borderRadius: "5px",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid rgb(126, 137, 168)",
              }}
            >
              <svg
                onClick={() => {
                  handleSearchKeyword(query);
                }}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginLeft: "10px", cursor: "pointer" }}
              >
                <path
                  d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                  stroke="#BDBDBD"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M14.0001 14.0001L11.1001 11.1001"
                  stroke="#BDBDBD"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <input
                ref={inputRef}
                type="text"
                placeholder={
                  authCtx.isAdmin
                    ? "Search by Meeting/Scribe Name"
                    : "Search by Meeting Name"
                }
                // onKeyDown={handleKeyDown}
                value={query}
                onChange={handleSearchChange}
                style={{
                  color: "rgb(126, 137, 168)",
                  background: "rgb(246, 246, 246)",
                  padding: "0px 10px",
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                width: "200px",
                height: "40px",
                borderRadius: "5px",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid rgb(126, 137, 168)",
                backgroundColor: "rgb(248, 248, 248)",
              }}
            >
              <select
                className="platform-select"
                style={{
                  flex: 1,
                  backgroundColor: "rgb(248, 248, 248)",
                  outline: "none",
                  color: "rgb(126, 137, 168)",
                  padding: "0px 10px",
                }}
                defaultValue=""
                value={platformSelected}
                onChange={(e) => {
                  console.log(e.target.value);
                  handleChangePlatform(e.target.value);
                }}
              >
                <option value="">Select</option>
                <option value="MEET">Google Meet</option>
                <option value="TEAMS">MS Teams</option>
                <option value="CUROGRAM">Curogram</option>
                <option value="ZOOM">Zoom</option>
              </select>
            </div>
            {/* <div
              style={{
                display: "flex",
                width: "360px",
                height: "40px",
                background: "#F6F6F6",
                borderRadius: 5,
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid rgba(126, 137, 168, 1)",
              }}
            >
              <Search style={{ marginLeft: 10 }} />
              <input
                type="text"
                placeholder={
                  authCtx.isAdmin
                    ? "Search by Meeting/Scribe Name"
                    : "Search by Meeting Name"
                }
                onKeyDown={handleKeyDown}
                value={query}
                onChange={handleInputChange}
                style={{
                  height: "38px",
                  color: "rgba(126, 137, 168, 1)",
                  background: "#F6F6F6",
                  border: "none",
                  borderRadius: "6px",
                  flex: "1 1",
                  outline: "none",
                  padding: "10px",
                }}
              />
            </div> */}

            <div
              style={{
                display: "flex",
                height: "40px",
                width: "200px",
                background: theme?.hightlightColor,
                borderRadius: 5,
                border: "1px solid rgba(110, 117, 255, 1)",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                cursor: "pointer",
                position: "relative",
                padding: "0 5px",
                gap: "5px",
                fontSize: "15px",
              }}
              onClick={() => {
                setShowDatePicker(true);
              }}
            >
              <ion-icon
                name="calendar-number-outline"
                style={{ fontSize: "20px" }}
              ></ion-icon>
              Select Date Range
            </div>
          </div>
        </>
      )}

      <DataTable
        paginationPerPage={rowsPerPage}
        paginationDefaultPage={pageNumber}
        paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
        onChangeRowsPerPage={setRowsPerPage}
        onChangePage={(val) => {
          console.log(val);
          setPageNumber(val);
        }}
        title="Transcriptions"
        pagination
        columns={columns}
        data={data}
        pointerOnHover
        highlightOnHover
        progressPending={pending}
        progressComponent={
          <div id="svg-container">
            <RotatingLines
              visible={true}
              height="96"
              width="96"
              color="red"
              strokeColor="grey"
              strokeWidth="4"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        }
        onRowClicked={(row, event) => {
          navigate(`/transcript-details?${row.id}`);
        }}
        paginationServer
        paginationServerOptions={{
          // persistSelectedOnPageChange: false,
          // custom: true,
          totalRows: totalRows,
          totalPages: Math.ceil(totalRows / rowsPerPage),
        }}
        paginationTotalRows={totalRows}
        onSort={handleSort}
        sortIcon
        theme={themeMode}
      />
    </div>
  );
};

export default Table;
